import $ from 'jquery';

$(document).on('ready', function(){

    const block = $('.wp-block-illi-blocks-header');
    const mobileMenu = $('.mobile-menu', block);
    
    $('.menu-item-has-children > a', mobileMenu).on('click', function(e){
        e.preventDefault();
        
        console.warn('test');
        $(this).closest('.menu-item-has-children').toggleClass('active');

    });



});